<script lang="ts">
	import { margin, marginInput } from '$lib/home/userInteract/store';
	import BigNumber from 'bignumber.js';
	import { createScWalletActiveStep } from '../popupsStore';

	import CreateScWalletModal from '$lib/popups/createSCWallet/CreateSCWalletModal.svelte';
	import DepositFundsModal from './DepositFundsModal.svelte';

	let minDepositInputNeeded: string = '0';
	let isMinMarginAfterDepositSufficient: boolean = false;
	$: if ($margin && $marginInput) {
		minDepositInputNeeded = new BigNumber('50')
			.multipliedBy(1e18)
			.minus(new BigNumber($margin))
			.toString();
		isMinMarginAfterDepositSufficient = new BigNumber($marginInput).gt(
			new BigNumber(minDepositInputNeeded)
		);
	}
</script>

{#if $createScWalletActiveStep == '1. Create Account'}
	<CreateScWalletModal />
{:else}
	<DepositFundsModal
		title="Your Polynomial Wallet is successfully"
		title2="created!"
		minDepositNeeded="100"
	/>
{/if}
